import { toast } from "react-toastify";
import { TokenDecrypt } from "../../../Shared/Utils/encryptionDecryption";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { getAnmProfileFromServer } from "../../../Services/AnmService";
import {
  fetchOnIncentive,
  getTotalAshaAnmData,
  fetchIncentiveActivity,
} from "../../../Services/DashboardService";
import { getAshaByRegionTable } from "../../../Services/AshaDeployedByRegionTableService";
import { convertDataBToDataA } from "../../../Shared/Utils/BackendPaeser";
// const roles = sessionStorage.getItem("userRole");
export const FETCH_TOP_ASHA_DATA = "FETCH_TOP_ASHA_DATA";
export const FETCH_TOP_ASHA_DATA_SUCCESS = "FETCH_TOP_ASHA_DATA_SUCCESS";
export const FETCH_TOP_ASHA_DATA_FAILURE = "FETCH_TOP_ASHA_DATA_FAILURE";
export const FETCH_ASHA_PROFILE = "FETCH_ASHA_PROFILE";
export const FETCH_ASHA_PROFILE_SUCCESS = "FETCH_ASHA_PROFILE_SUCCESS";
export const FETCH_ASHA_PROFILE_ERROR = "FETCH_ASHA_PROFILE_ERROR";
export const FETCH_ASHA_SCHEMES = "FETCH_ASHA_SCHEMES";
export const FETCH_ASHA_SCHEMES_SUCCESS = "FETCH_ASHA_SCHEMES_SUCCESS";
export const FETCH_ASHA_SCHEMES_ERROR = "FETCH_ASHA_SCHEMES_ERROR";
export const SEND_REMINDER = "SEND_REMINDER";
export const SEND_REMINDER_SUCCESS = "SEND_REMINDER_SUCCESS";
export const SEND_REMINDER_FAILURE = "SEND_REMINDER_FAILURE";
export const FETCH_ASHAS_ON_INCENTIVES = "FETCH_ASHAS_ON_INCENTIVES";
export const FETCH_ASHAS_ON_INCENTIVES_SUCCESS =
  "FETCH_ASHAS_ON_INCENTIVES_SUCCESS";
export const FETCH_ASHAS_ON_INCENTIVES_FAILURE =
  "FETCH_ASHAS_ON_INCENTIVES_FAILURE";
export const NO_RECORDS_FOUND_ACTION = "NO_RECORDS_FOUND_ACTION";
export const FETCH_INCENTIVE_DETAILS_SUCCESS =
  "FETCH_INCENTIVE_DETAILS_SUCCESS";
export const FETCH_ANM_PROFILE_SUCCESS = "FETCH_ANM_PROFILE_SUCCESS";
export const FETCH_ANM_PROFILE_ERROR = "FETCH_ANM_PROFILE_ERROR";
export const FETCH_ANM_PROFILE = "FETCH_ANM_PROFILE";
export const FETCH_TOTAL_ASHA_ANM_DATA = "FETCH_TOTAL_ASHA_ANM_DATA";
export const FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS =
  "FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS";
export const FETCH_TOTAL_ASHA_ANM_DATA_FAILURE =
  "FETCH_TOTAL_ASHA_ANM_DATA_FAILURE";
export const FETCH_ANM_ASHA_LIST = "FETCH_ANM_ASHA_LIST";
export const FETCH_ANM_ASHA_LIST_SUCCESS = "FETCH_ANM_ASHA_LIST_SUCCESS";
export const FETCH_ANM_ASHA_LIST_FAILURE = "FETCH_ANM_ASHA_LIST_FAILURE";
export const FETCH_ANM_ACTIVITY_INCENTIVE_SUCCESS =
  "FETCH_ANM_ACTIVITY_INCENTIVE_SUCCESS";
export const FETCH_ANM_ACTIVITY_INCENTIVE_FAILURE =
  "FETCH_ANM_ACTIVITY_INCENTIVE_FAILURE";
export const FETCH_ANM_ACTIVITY_INCENTIVE = "FETCH_ANM_ACTIVITY_INCENTIVE";
export const FETCH_ANM_APPROVED_PENDING_REQUESTS =
  "FETCH_ANM_APPROVED_PENDING_REQUESTS";
export const FETCH_ANM_APPROVED_PENDING_REQUESTS_SUCCESS =
  "FETCH_ANM_APPROVED_PENDING_REQUESTS_SUCCESS";
export const FETCH_ANM_APPROVED_PENDING_REQUESTS_FAILURE =
  "FETCH_ANM_APPROVED_PENDING_REQUESTS_FAILURE";
export const FETCH_INCENTIVE_DETAILS_FAILURE =
  "FETCH_INCENTIVE_DETAILS_FAILURE";
export const FETCH_ASHAS_ON_ANM = "FETCH_ASHAS_ON_ANM";
export const FETCH_ASHAS_ON_ANM_SUCCESS = "FETCH_ASHAS_ON_ANM_SUCCESS";
export const FETCH_ASHAS_ON_ANM_FAILURE = "FETCH_ASHAS_ON_ANM_FAILURE";
export const FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT =
  "FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT";
export const FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_SUCCESS =
  "FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_SUCCESS";
export const FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_FAILURE =
  "FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_FAILURE";
export const FETCH_ASHA_BY_REGION_TABLE = "FETCH_ASHA_BY_REGION_TABLE";
export const FETCH_ASHA_BY_REGION_TABLE_SUCCESS =
  "FETCH_ASHA_BY_REGION_TABLE_SUCCESS";
export const FETCH_ASHA_BY_REGION_TABLE_FAILURE =
  "FETCH_ASHA_BY_REGION_TABLE_FAILURE";
const successToastStyle = {
  width: "30rem",
  background: "#DEF0E7",
  color: "#209860",
  borderColor: "2px solid #209860",
};
export const fetchAshaProfile = (ashaId, langId) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ASHA_PROFILE, payload: ashaId });
    axiosInstance
      .get(`/api/getAshaProfile/${langId}/${ashaId}`)
      .then((response) => {
        const decrypted = TokenDecrypt(response.data);
        dispatch({ type: FETCH_ASHA_PROFILE_SUCCESS, payload: decrypted });
      })
      .catch((error) => {
        dispatch({ type: FETCH_ASHA_PROFILE, payload: error.message });
      });
  };
};
export const fetchAshaSchemes = (ashaId, langId) => {
  return (dispatch) => {
    axiosInstance
      .get(`/api/getSchemes/${langId}/${ashaId}`)
      .then((response) => {
        const decrypted = TokenDecrypt(response.data);
        dispatch({ type: FETCH_ASHA_SCHEMES_SUCCESS, payload: decrypted });
      })
      .catch((error) => {
        dispatch({ type: FETCH_ASHA_SCHEMES_ERROR, payload: error.message });
      });
  };
};

const createRequestBodyfetchTopAshaData = (
  areaid,
  month,
  year,
  selectedLanguageId,
  decrypted,
  sortType
) => {
  const sortBy = sortType || "highestToLowest";
  return {
    sortBy,
    roleName: "ASHA",
    month,
    year,
    languageid: selectedLanguageId.toString(),
    areaId: areaid,
    state: decrypted.stateId ? [decrypted.stateId] : [],
    district: decrypted.districtId ? [decrypted.districtId] : [],
    taluka: decrypted.talukaId ? [decrypted.talukaId] : [],
    phc: decrypted.phcId ? [decrypted.phcId] : [],
  };
};
export const fetchTopAshaData = (
  areaid,
  month,
  year,
  selectedLanguageId,
  sortType
) => {
  const tokenData = sessionStorage.getItem("entireToken");
  const decrypted = TokenDecrypt(tokenData);

  return async (dispatch) => {
    dispatch({ type: FETCH_TOP_ASHA_DATA });
    try {
      const requestBody = createRequestBodyfetchTopAshaData(
        areaid,
        month,
        year,
        selectedLanguageId,
        decrypted,
        sortType
      );
      const response = await axiosInstance.post(
        "/api/getTopFiveperformers",
        requestBody
      );
      const decrypt = TokenDecrypt(response.data.data);
      dispatch({ type: FETCH_TOP_ASHA_DATA_SUCCESS, payload: decrypt });
    } catch (error) {
      dispatch({ type: FETCH_TOP_ASHA_DATA_FAILURE, payload: error });
    }
  };
};

export const sendAshaReminder = (ashaIds, reminderText) => {
  return async (dispatch) => {
    const reqObj = {
      ashaIds: ashaIds.map((el) => el.toString()),
      message: reminderText,
    };

    try {
      const response = await axiosInstance.post(
        "/reminder/adminsendReminder",
        reqObj
      );
      dispatch({ type: SEND_REMINDER });
      dispatch({ type: SEND_REMINDER_SUCCESS, payload: reqObj });
      toast.success("Reminder Sent Successfully", {
        style: successToastStyle,
      });
    } catch (error) {
      console.error("Error sending reminder:", error);
    }
  };
};
//total active & inactive card

export const fetchActiveInactiveCardDataCount = (areaId, roles) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT });
    const tokenData = sessionStorage.getItem("entireToken");
    const decrypted = TokenDecrypt(tokenData);
    try {
      const requestBody = {
        areaId: areaId,
      };

      if (roles === "Admin" || roles === "Support Admin") {
        requestBody.districtIds = decrypted.districtId
          ? [decrypted.districtId]
          : [];
        requestBody.talukaIds = decrypted.talukaId ? [decrypted.talukaId] : [];
        requestBody.phcIds = [];
        requestBody.stateId = decrypted.stateId
        ? decrypted.stateId
        : 0;
      } else if (
        roles === "PHC MO" ||
        roles === "District Level Head" ||
        roles === "Block Level Head"
      ) {
        requestBody.districtIds = decrypted.districtId
          ? [decrypted.districtId]
          : [];
        requestBody.talukaIds = decrypted.talukaId ? [decrypted.talukaId] : [];
        requestBody.phcIds = decrypted.phcId ? [decrypted.phcId] : [];
        requestBody.stateId = decrypted.stateId
        ? decrypted.stateId
        : 0;
      }
      const resp = await axiosInstance.post(
        "/api/getAshaANMByStatus",
        requestBody
      );
      const decrypt = TokenDecrypt(resp.data);
      dispatch({
        type: FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_SUCCESS,
        payload: { data: decrypt },
      });
    } catch (error) {
      dispatch({
        type: FETCH_ACTIVE_INACTIVE_CARD_DATA_COUNT_FAILURE,
        payload: error,
      });
    }
  };
};
export const fetchTotalAshaAnmData = (
  areaType,
  chosenRole,
  month,
  year,
  selectedLanguageId,
  tabIndex,
  page,
  pageSize
) => {
  return async (dispatch) => {
    const reqObj = {
      areaType,
      chosenRole,
      month,
      year,
      selectedLanguageId,
    };
    dispatch({ type: FETCH_TOTAL_ASHA_ANM_DATA, payload: reqObj });
    try {
      const aptRes = await getTotalAshaAnmData(
        areaType,
        chosenRole,
        month,
        year,
        selectedLanguageId,
        tabIndex,
        page,
        pageSize 
      );
      const parshedRes = convertDataBToDataA(aptRes.data);
      dispatch({
        type: FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS,
        payload: parshedRes.ashaList,
        paginationData: 
        { totalCount: aptRes?.totalCount || 0, 
          page: aptRes?.page || 1,
          pageSize: aptRes?.pageSize || 10
        }
      });
    } catch (error) {
      dispatch({
        type: FETCH_TOTAL_ASHA_ANM_DATA_SUCCESS,
      });
    }
  };
};
export const fetchAshasOnIncentive = (
  area,
  selectedLanguageId,
  district,
  taluka,
  roles,
  selectedMonth,
  selectedYear
) => {
  return (dispatch) => {
    fetchOnIncentive(
      area,
      selectedLanguageId,
      district,
      taluka,
      roles,
      selectedMonth,
      selectedYear
    )
      .then((data) => {
        dispatch({ type: FETCH_ASHAS_ON_INCENTIVES_SUCCESS, payload: data });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ASHAS_ON_INCENTIVES_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const fetchIncentiveDetails = (
  ashaId,
  selectedLanguageId,
  month,
  year
) => {
  return async (dispatch) => {
    try {
      const response = await fetchIncentiveActivity(
        ashaId,
        selectedLanguageId,
        month,
        year
      );
      dispatch({ type: FETCH_INCENTIVE_DETAILS_SUCCESS, payload: response });
    } catch (error) {
      dispatch({
        type: FETCH_INCENTIVE_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const fetchAnmProfile = (anmId, selectedLanguageID) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ANM_PROFILE, payload: anmId });
    try {
      const res = await getAnmProfileFromServer(selectedLanguageID, anmId);
      const decrypt = TokenDecrypt(res.data);
      dispatch({ type: FETCH_ANM_PROFILE_SUCCESS, payload: decrypt });
    } catch (error) {
      console.log(
        "An error occurred while fetching ANM profile:",
        error.message
      );
      dispatch({ type: FETCH_ANM_PROFILE_ERROR, payload: error.message });
    }
  };
};

export const fetchListOfAshas = (
  anmId,
  selectedLanguageId,
  district,
  taluka
) => {
  return (dispatch) => {
    const requestData = {
      district: district,
      taluka: taluka,
    };
    axiosInstance
      .post(
        `/api/getAshaProfileByANM/${selectedLanguageId}/${anmId}`,
        requestData
      )
      .then((response) => {
        const decrypt = TokenDecrypt(response.data);
        dispatch({ type: FETCH_ANM_ASHA_LIST_SUCCESS, payload: decrypt });
      })

      .catch((error) => {
        dispatch({ type: FETCH_ANM_ASHA_LIST_FAILURE, payload: error.message });
      });
  };
};
export const fetchActivityandIncentive = (anmId, month, year) => {
  return (dispatch) => {
    const activityandIncentive = {
      incentiveDetails: [
        {
          activitycount: 1,
          activityname:
            "Incentive to ASHA for quarterly visits u/HBYC for 7 Aspirational district n Karimganj\n",
          amountpercase: 220,
          ashaCount: 4,
        },
        {
          activitycount: 2,
          activityname:
            "Incentive to ASHA for quarterly visits u/HBYC for 7 Aspirational district Karimganj\n",
          amountpercase: 250,
          ashaCount: 6,
        },
        {
          activitycount: 3,
          activityname: "Incentive for quarterly mothers' meeting under MAA\n",
          amountpercase: 150,
          ashaCount: 10,
        },
        {
          activitycount: 4,
          activityname:
            "Incentive to ASHA for follow up of SNCU discharge babies and for follow up of LBW babies\n",
          amountpercase: 400,
          ashaCount: 5,
        },
        {
          activitycount: 5,
          activityname:
            "Providing HBNC up to 42 days after birth / discharge from SNCU\n",
          amountpercase: 200,
          ashaCount: 7,
        },
      ],
    };
    dispatch({
      type: FETCH_ANM_ACTIVITY_INCENTIVE_SUCCESS,
      payload: activityandIncentive.incentiveDetails,
    });
  };
};

export const fetchApprovedRequests = (anmId, month, year) => {
  return (dispatch) => {
    const approvedPendingRequest = {
      requests: [
        {
          name: "Riddhima",
          ashaid: "NRHMASHA040",
          isActive: true,
          amount: "5000",
          pendingSince: 190,
          totalCount: 6,
          claimDate: "31-06-2023",
          approveddate: null,
        },
        {
          name: "Yogita",
          ashaid: "NRHMASHA00044",
          isActive: true,
          amount: "4500",
          pendingSince: 190,
          totalCount: 6,
          claimDate: "2-06-2023",
          approveddate: "12-11-2023",
        },
        {
          name: "Seema",
          ashaid: "NRHMASHA0036",
          isActive: false,
          amount: "3000",
          pendingSince: 190,
          totalCount: 6,
          claimDate: "3-06-2023",
          approveddate: "13-11-2023",
        },
        {
          name: "Rekha",
          ashaid: "NRHMASHA0060",
          isActive: false,
          amount: "3500",
          pendingSince: 190,
          totalCount: 6,
          claimDate: "8-06-2023",
          approveddate: "14-11-2023",
        },
      ],
    };
    dispatch({
      type: FETCH_ANM_APPROVED_PENDING_REQUESTS_SUCCESS,
      payload: approvedPendingRequest.requests,
    });
  };
};
export const fetchAshaInANM = (anmId, selectedLanguageId) => {
  return (dispatch) => {
    dispatch({ type: FETCH_ASHAS_ON_ANM, payload: anmId });
    axiosInstance
      .get(`getAshaProfileByANM/${selectedLanguageId}/${anmId}`)
      .then((response) => {
        dispatch({ type: FETCH_ASHAS_ON_ANM_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: FETCH_ASHAS_ON_ANM_FAILURE, payload: error.message });
      });
  };
};

export const fetchAshaByRegionTable = (
  tribal,
  month,
  year,
  selectedLanguageId
) => {
  return async (dispatch) => {
    try {
      const data = await getAshaByRegionTable(
        tribal,
        month,
        year,
        selectedLanguageId
      );
      dispatch({ type: "FETCH_ASHA_BY_REGION_TABLE_SUCCESS", payload: data });
    } catch (error) {
      dispatch({
        type: "FETCH_ASHA_BY_REGION_TABLE_FAILURE",
        payload: error.message,
      });
    }
  };
};
